<i18n src="../../locales/lang.json"></i18n>
<template>
  <span>
    <a v-show="enabled == true" @click="doRead()" class="btn btn-link btn-warning" style="color:white;">{{$t('mark_as_read')}}</a>
    <span class="ml-2 mt-2 text-muted" style="display:inline-block" v-show="enabled == false">{{$t('i_have_read_this')}} <i class="icon-checkmark2 success"></i></span>
  </span>
</template>

<script>
  export default {
    name: 'button-read-this',
    components: {
    },
    props: {
      enabled: {
        required: false,
        type: Boolean,
        default: false
      },
      notificationid: {
        required: false,
        type: Number,
        default: -1
      },
      callfunc: {
        required: false,
        type: String,
        default: null
      }
    },
    methods: {
      doRead() {
        if (this.enabled == false)
          return;
        try {
          this.$http.patch('/api/Notification/v1/' + this.notificationid + '/read').then(response => {
            if (this.callfunc != null) {
              // Calling the function name in the parameter
              eval(this.callfunc + '();');
            }
           // getNewsNotifcation();
          });
          this.enabled = false;
          this.$forceUpdate();


        } catch (err) {
          alert(err);
        }
      }


    },
    created() {

    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/discuss/button-read-this.vue